/**
 * Component for initializing Launch Darkly and observing user changes that
 * may require re-identifying the user
 */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
  }),
  getFlagsHandler: PropTypes.func.isRequired,
  unsubscribeHandler: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

const defaultProps = {
  user: {},
  children: null,
};

class FeatureFlags extends React.Component {
  componentDidMount() {
    const { user, getFlagsHandler } = this.props;
    getFlagsHandler(user);
  }

  shouldComponentUpdate(nextProps) {
    const { user, getFlagsHandler } = this.props;
    // Only test fields on user state that are relevant for feature switch
    return (
      nextProps.getFlagsHandler !== getFlagsHandler ||
      nextProps.user.id !== user.id ||
      nextProps.user.email !== user.email ||
      nextProps.user.name !== user.name
    );
  }

  componentDidUpdate() {
    const { user, getFlagsHandler } = this.props;
    getFlagsHandler(user);
  }

  componentWillUnmount() {
    const { unsubscribeHandler } = this.props;
    unsubscribeHandler();
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

FeatureFlags.propTypes = propTypes;
FeatureFlags.defaultProps = defaultProps;

export default FeatureFlags;
